import { render } from "./SignedImage.vue?vue&type=template&id=37c1044a&scoped=true"
import script from "./SignedImage.vue?vue&type=script&lang=js"
export * from "./SignedImage.vue?vue&type=script&lang=js"

import "./SignedImage.vue?vue&type=style&index=0&id=37c1044a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c1044a"]])

export default __exports__